import { useEffect, useRef, useState } from 'react'
import { ReactComponent as Dot } from '../assets/icons/dot.svg'
import { ReactComponent as Search } from '../assets/icons/search.svg'
import { ReactComponent as Add } from '../assets/icons/add.svg'
import { ReactComponent as Close } from '../assets/icons/close.svg'
import { ReactComponent as Delete } from '../assets/icons/delete.svg'
import { ReactComponent as CloseFilled } from '../assets/icons/close-filled.svg'
import { deleteCoursesStudent, getCoursesStudent } from '../apis/course.ts'
import { DeleteModal } from './Modal.jsx'
import StudentAddModal from './StudentAddModal.jsx'

export default function ClassStudentTab({ courseId, semesterId }) {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [studentList, setStudentList] = useState()
  const sortedByList = [
    { id: 1, name: '햑급번호 순', type: 'studentId' },
    { id: 2, name: '이름 순', type: 'name' },
    { id: 3, name: '최근 등록 순', type: 'recent' },
  ]

  const [sortedBy, setSortedBy] = useState(1)
  const [selectedStudent, setSelectedStudent] = useState([])
  const [search, setSearch] = useState('')

  const handleSelectClick = (studentItem) => {
    if (!selectedStudent.includes(studentItem.id)) {
      setSelectedStudent((prev) => [...prev, studentItem.id])
    } else {
      const unSelectedStudent = selectedStudent.filter((item) => item !== studentItem.id)
      setSelectedStudent(unSelectedStudent)
    }
  }

  const getCategoryType = (id) => {
    const item = sortedByList.find((item) => item.id === id)
    return item.type
  }

  /*************** 외부 영역 클릭 Ref **************/
  const studentRef = useRef()
  useEffect(() => {
    function handleClickOutside(e) {
      if (studentRef.current && !studentRef.current.contains(e.target)) {
        setSelectedStudent([])
      }
    }

    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [studentRef])

  /*************** 수업 학생 조회 API **************/
  useEffect(() => {
    getCoursesStudentApi()
    // eslint-disable-next-line
  }, [sortedBy, search])

  const getCoursesStudentApi = async () => {
    const getCoursesStudentResponse = await getCoursesStudent({
      courseId: courseId,
      sortBy: getCategoryType(sortedBy),
      name: search,
    })

    if (getCoursesStudentResponse.error) {
      console.log(getCoursesStudentResponse)
      return
    } else {
      setStudentList(getCoursesStudentResponse.data)
    }
  }

  /*************** 수업 학생 삭제 API **************/
  const deleteCoursesStudentApi = async () => {
    const deleteCoursesStudentResponse = await deleteCoursesStudent(
      {
        courseId: courseId,
      },
      selectedStudent,
    )
    if (deleteCoursesStudentResponse.error) {
      console.log(deleteCoursesStudentResponse.message)
      return
    } else {
      console.log(deleteCoursesStudentResponse.result)
      await getCoursesStudentApi()
      setSelectedStudent([])
    }
  }

  return (
    <div className='border_default h-full overflow-hidden rounded-16 bg-background-default px-24 py-20'>
      {/* menu */}
      <div ref={studentRef} className='flex h-full flex-col gap-16'>
        {selectedStudent.length > 0 ? (
          <div className='border_default flex min-h-[38px] w-full items-center gap-24 rounded-16 bg-background-default px-16 py-4'>
            <div
              onClick={() => setSelectedStudent([])}
              className='flex items-center gap-4 fill-label-sub py-4'
            >
              <Close />
              <p className='text-body2-medium text-label-sub'>{selectedStudent.length}명 선택</p>
            </div>
            <div className='h-20 w-[1px] bg-border-default' />
            <div
              onClick={() => setIsDeleteModalOpen(true)}
              className='flex items-center gap-4 fill-status-negative py-4'
            >
              <Delete />
              <p className='text-body2-medium text-status-negative'>선택삭제</p>
            </div>
          </div>
        ) : (
          <div className='flex min-h-[38px] justify-between'>
            <div className='flex items-center gap-16'>
              {sortedByList.map((item) => (
                <div
                  key={item.id}
                  onClick={() => setSortedBy(item.id)}
                  className={`flex cursor-pointer items-center justify-center gap-4 ${
                    sortedBy === item.id
                      ? 'fill-label-sub text-label-sub'
                      : 'fill-label-placeholder text-label-placeholder'
                  }`}
                >
                  <Dot />
                  <p className='text-body3-medium'>{item.name}</p>
                </div>
              ))}
            </div>
            <div className='flex items-center gap-8'>
              <div className='relative'>
                <Search className='absolute left-16 top-8' />
                <input
                  type='text'
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder='학생 검색'
                  className='input_sm pl-40'
                />
                {search && (
                  <CloseFilled
                    onClick={() => setSearch('')}
                    className='absolute right-8 top-8 cursor-pointer'
                  />
                )}
              </div>
              <button
                onClick={() => setIsAddModalOpen(true)}
                className='button_outlined_assistive_sm gap-4'
              >
                <Add className='h-16 w-16' />
                <p>학생 직접 추가</p>
              </button>
            </div>
          </div>
        )}
        {/* studentList */}
        <div className='h-full w-full'>
          <div className='flex w-full gap-24 border-y-[1px] border-solid border-border-default bg-fill-alternative px-16 py-8 text-body3-regular text-label-info'>
            <p className='min-w-[140px] shrink-0'>학급번호</p>
            <p className='min-w-[200px] shrink-0'>이름</p>
            <p className='min-w-[275px] shrink-0'>전공그룹</p>
            <p className='min-w-[140px] shrink-0'>등록 일자</p>
          </div>
          <div className='tab-scroll-bar h-[calc(100%-74px)] w-full overflow-y-auto pr-4'>
            {search && studentList.length === 0 ? (
              <div className='flex h-full w-full items-center justify-center'>
                <p className='text-center text-body1-long-medium text-label-placeholder'>
                  검색 결과가 없습니다.
                  <br />
                  검색하고자 하는 글자를 완전히 입력하거나 다른 검색어를 입력해보세요.
                </p>
              </div>
            ) : (
              studentList?.map((studentItem, studentIndex) => (
                <div
                  key={studentIndex}
                  onClick={() => handleSelectClick(studentItem)}
                  className={`${selectedStudent.includes(studentItem.id) ? 'bg-background-secondary' : 'bg-background-default'} flex gap-24 border-b-[1px] border-solid border-border-default p-16 text-body2-medium text-label-sub active:bg-background-secondary`}
                >
                  <p className='min-w-[140px] shrink-0'>
                    {`${studentItem.grade}학년 ${studentItem.classNumber}반 ${studentItem.studentNumber}번`}
                  </p>
                  <p className='min-w-[200px] shrink-0'>{studentItem.name}</p>
                  <p className='min-w-[275px] shrink-0'>{studentItem.majorGroup}</p>
                  <p className='min-w-[140px] shrink-0'>{studentItem.enrolledTime}</p>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
      {isDeleteModalOpen && (
        <DeleteModal
          close={() => setIsDeleteModalOpen(false)}
          content={'student'}
          onStateChange={() => setIsDeleteModalOpen(false)}
          deleteApi={() => deleteCoursesStudentApi()}
          // getApi={getSessionsApi}
        />
      )}
      {isAddModalOpen && (
        <StudentAddModal
          close={() => setIsAddModalOpen(false)}
          courseId={courseId}
          getApi={() => getCoursesStudentApi()}
          semesterId={semesterId}
          existingStudent={studentList}
        />
      )}
    </div>
  )
}
